const array = [
  {
    path: '/events/lives/:id',
    name: 'events_lives',
    props: true,
    component: () => import('./pages/Lives.vue'),
    meta: {
      requiresAuth: true,
      pageTitle: 'Eventos',
      breadcrumb: [
        {
          text: 'Eventos',
          active: true,
        },
      ],
    },
  },
  {
    path: '/events/live/:id/:id_old',
    name: 'live_show',
    props: true,
    component: () => import('./pages/LiveEvent.vue'),
    meta: {
      requiresAuth: true,
      pageTitle: 'Eventos',
      breadcrumb: [
        {
          text: 'Eventos',
          active: true,
        },
      ],
    },
  }
]

export default array
